<template>
    <div v-if="dossier">
        <h3 id="top-feuillet">{{$t("Bareme.etape4.titre")}}</h3>
        <div class="row">
            <div class="col-md-12">
                <div class="field field-name-body field-type-text-with-summary field-label-hidden">
                    <div class="field-items">
                        <div class="field-item even">
                            <p v-html="getPanelContenu()"></p>
                            <button class="btn btn-primary" @click="onGenererPdf"
                                    :title="$t('Bareme.etape4.buttons.genererPDFAide')">
                                {{ $t('Bareme.etape4.buttons.genererPDF')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h4>{{ $t('Bareme.etape4.titreFormulaire')}}</h4>
        <resultat-bareme :resultat="resultat"></resultat-bareme>

        <button class="btn btn-default" style="margin-right:5px;" @click="onRetour"
                :title="$t('general.btnRetourTitle')">
            {{this.$t("general.btnRetour")}}
        </button>
        <button @click="onSubmit" class="btn btn-primary "
                :title="$t('Bareme.etape4.buttons.retourEtape1Aide')">
            {{$t('Bareme.etape4.buttons.retourEtape1')}}
        </button>
    </div>
</template>

<script>

import ImpotSourceRestApi from '@/services/ImpotSourceRestApi';
import TitreRestApi from '@/services/TitreRestApi';
import ContribuableIsDto from '@/models/bareme/ContribuableIsDto';
import ProgressBarUtils from '@/utils/ProgressBarUtils';
import ResultatBareme from '../section_calculette/SectionResultat.vue';
import RestErreur from '../../../utils/RestErreur';

const BigNumber = require('bignumber.js');

export default {
  name: 'bareme-etape-4',
  components: {
    ResultatBareme,
  },
  mixins: [ProgressBarUtils],
  props: ['resultat'],
  computed: {
    dossier() {
      return this.$store.getters['dossier/getDossier'];
    },
  },
  methods: {
    onSubmit() {
      this.initProgressBar(2, [this.$t('Bareme.progressBar.etape1'), this.$t('Bareme.progressBar.etape2')], 1, this.$t('Bareme.titre'));
      this.$router.push({ name: 'routePrelevementEtape1' });
    },
    onRetour(e) {
      e.preventDefault();
      this.$router.push({ name: 'routePrelevementEtape3' });
    },
    async onGenererPdf() {
      const contribuableIsDto = new ContribuableIsDto();
      contribuableIsDto.frontalier = this.dossier.typeResident.value;
      contribuableIsDto.etatCivil = this.dossier.etatCivil.code;
      contribuableIsDto.enfantaCharge = this.dossier.hasEnfants;
      contribuableIsDto.conjointRevenu = this.dossier.hasConjointRevenu;
      contribuableIsDto.annee = this.resultat.annee;
      contribuableIsDto.codeBareme = this.dossier.bareme;
      contribuableIsDto.bareme = this.dossier.bareme;
      contribuableIsDto.baremeAjuste = this.resultat.typeBaremeAjuste === 'AUCUN' ? null : this.resultat.baremeAjuste;
      contribuableIsDto.nom = this.dossier.nom;
      contribuableIsDto.prenom = this.dossier.prenom;
      contribuableIsDto.noAvs = this.dossier.numeroAVS;
      contribuableIsDto.noMatricule = this.dossier.noCollaborateur;
      contribuableIsDto.isRevenuUnSeulEmployeur = this.dossier.isRevenuUnSeulEmployeur;

      contribuableIsDto.revenu = this.resultat.revenuContribuableCHF ? new BigNumber(this.resultat.revenuContribuableCHF) : null;
      contribuableIsDto.revenuEUR = this.resultat.revenuContribuableEUR ? new BigNumber(this.resultat.revenuContribuableEUR) : null;
      contribuableIsDto.revenuConjoint = this.resultat.revenuConjointCHF ? new BigNumber(this.resultat.revenuConjointCHF) : null;
      contribuableIsDto.revenuConjointEUR = this.resultat.revenuConjointEUR ? new BigNumber(this.resultat.revenuConjointEUR) : null;

      let tauxChange = await new TitreRestApi().getTauxChange(this.resultat.annee, 'EUR');
      if (tauxChange instanceof RestErreur) {
        tauxChange = null;
      }
      contribuableIsDto.tauxChange = tauxChange;
      if (this.dossier.remarques.length > 0 && (this.dossier.remarques[0] !== '' || this.dossier.remarques[1] !== '')) {
        contribuableIsDto.communications = this.dossier.remarques;
      }
      contribuableIsDto.adresse = {
        rue: this.dossier.adresseRue,
        localite: this.dossier.adresseLocalite,
      };
      if (this.dossier.isConjointFonctionnaireInt) {
        contribuableIsDto.conjointFonctionnaireInternationale = this.dossier.isConjointFonctionnaireInt;
      }
      if (this.dossier.typeFonctInt) {
        contribuableIsDto.typeFonctionnaireInternational = this.dossier.typeFonctInt.value;
      }
      contribuableIsDto.isEnUnionLibre = this.dossier.isUnionLibre;
      contribuableIsDto.gardeAlternee = this.dossier.isGardeAlternee;
      if (this.dossier.hasEnfants) {
        contribuableIsDto.dateNaissanceEnfants = this.dossier.datesNaissanceEnfants.map(k => k.dateNaissance);
      }
      contribuableIsDto.nbEnfantBaremeH = this.dossier.nbEnfants;
      if (this.dossier.etatCivil.code === 'Marie') {
        contribuableIsDto.conjointRevenuOu = this.dossier.sourceRevenu.map(k => k.code);
      }
      contribuableIsDto.canton = this.dossier.canton ? this.dossier.canton.code : null;
      contribuableIsDto.dateChangementEtatCivil = this.dossier.dateChangementEtatCivil;
      contribuableIsDto.tauxGlobalActivite = this.dossier.tauxGlobalActivite;
      // eslint-disable-next-line
      new ImpotSourceRestApi().getPdf(contribuableIsDto);
    },
    getPanelContenu() {
      if (this.resultat.typeBaremeAjuste === 'AUCUN') {
        return this.$t('Bareme.etape4.panelInfo.panelContenu2');
      }
      return this.$t('Bareme.etape4.panelInfo.panelContenu', {
        typeBareme: (this.resultat.typeBaremeAjuste === 'HAUSSE' ? ` à la hausse ${this.resultat.baremeAjuste}` : ` à la baisse ${this.resultat.baremeAjuste}`),
        tauxALaBaisse: this.resultat.tauxALaBaisse,
        tauxALaHausse: this.resultat.tauxALaHausse,
      });
    },
  },
  created() {
    if (!this.dossier) {
      this.$router.push({ name: 'routePrelevementEtape1' });
      return;
    }
    this.initProgressBar(4, [this.$t('Bareme.progressBar.etape1'), this.$t('Bareme.progressBar.etape2'),
      this.$t('Bareme.progressBar.etape3'), this.$t('Bareme.progressBar.etape4')], 4, this.$t('Bareme.titre'));
  },
};
</script>

<style scoped>

</style>
